import Reflux        from 'reflux';
import StoreState    from 'mixins/store_state';
import {AmpPlayerActions} from 'actions/amp-player-actions';

export default Reflux.createStore({
  listenables: [ ],
  mixins: [ StoreState ],
  init() {
    this.state = this.getInitialState();
    this.listenTo(AmpPlayerActions.volumechange, this.onVideoVolumeChange.bind(this));
  },
  getInitialState() {
    return { 
      isVisible: true
    };
  },
  onVideoVolumeChange(mediaApi){
        if(mediaApi.getVolume()>0){
            this.stopListeningTo(AmpPlayerActions.volumechange);
            this.setState({
                isVisible: false
            })
        }
    }
});










// WEBPACK FOOTER //
// ./modules/stores/tap-for-sound-store.js